import GLightbox from 'glightbox';
import 'glightbox/src/postcss/glightbox.css';

const lightbox = new GLightbox({
  selector: '.c-modal__trigger',
  touchNavigation: true,
  loop: false,
  autoplayVideos: false,
  openEffect: 'zoom',
  closeEffect: 'zoom',
  zoomable: false
});

export default lightbox;
